import axios from "../libs/api.request.js";
// 字典
export const dictbasic = params => {
  return axios.request({
    url: "pc/dictbasic",
    method: "get",
    params: params
  });
};
// 字典
export const getDictSystem = params => {
  return axios.request({
    url: "pc/dictsystem/getDictSystem",
    method: "get",
    params: params
  });
};
// 附件上传
export const uploadAttachment = data => {
  return axios.request({
    url: "pc/attachment/upload",
    method: "post",
    data
  });
};
// 附件删除
export const deleteAttachment = data => {
  return axios.request({
    url: "pc/attachment",
    method: "DELETE",
    data: data.ids
  });
};
// 保存
export const saveAttachment = data => {
  return axios.request({
    url: "pc/attachment/save",
    method: "post",
    data
  });
};
// 省市区
export const dictList = params => {
  return axios.request({
    url: "pc/expressdict/list",
    method: "get",
    params
  });
};
// 获得产品分类
export const dictbasicList = params => {
  return axios.request({
    url: "pc/dictbasic/list",
    method: "get",
    params
  });
};
// 类型
export const getDealItem = params => {
  return axios.request({
    url: "pc/dictsystem/getDealItem",
    method: "get",
    params
  });
};

// 获得下单方式
export const listDictSystem = params => {
  return axios.request({
    url: "pc/dictsystem/listDictSystem",
    method: "get",
    params
  });
};
// 获得量体风格
export const styleAuthInfo = params => {
  return axios.request({
    url: "/pc/dict/styleAuthInfo",
    method: "get",
    params
  });
};

// 衬类型
export const selectDictBasicTrees = params => {
  return axios.request({
    url: `/pc/membercmt/currentCmtList/${params.category}/${params.orderType}`,
    method: "get",
    // params
  });
};
// 提交计算
export const calculatePriceHeader = data => {
  return axios.request({
    url: "pc/membercost/calculatePrice",
    method: "post",
    data
  });
};
// 获得产品品类
export const getCategory = params => {
  return axios.request({
    url: "pc/dict/category",
    method: "get",
    params
  });
};
// s\首页banner
export const banner = params => {
  return axios.request({
    url: "/pc/banner",
    method: "get",
    params
  });
};
// 获得工艺
export const zzCraft = params => {
  return axios.request({
    url: "pc/dict/zzCraft",
    method: "get",
    params
  });
};
// 获得刺绣
export const zzEmb = params => {
  return axios.request({
    url: "pc/dict/zzEmb",
    method: "get",
    params
  });
};
// 撞色面料
export const zzContrast = params => {
  return axios.request({
    url: "pc/dict/zzContrast",
    method: "get",
    params
  });
};
// 工艺
export const searchCraft = data => {
  return axios.request({
    url: "pc/dict/searchCraft",
    method: "post",
    data
  });
};
// 特体信息
export const specBody = params => {
  return axios.request({
    url: "pc/dict/specBody",
    method: "get",
    params
  });
};
// 特体信息 newOrder 特体
export const zzSpecBody = params => {
  return axios.request({
    url: "pc/dict/zzSpecBody",
    method: "get",
    params
  });
};
// 特体信息 款式下单 特体
export const styleSpecBody = params => {
  return axios.request({
    url: "pc/dict/styleSpecBody",
    method: "get",
    params
  });
};
// 着装风格
export const styleInfo = params => {
  return axios.request({
    url: "pc/dict/styleInfo",
    method: "get",
    params
  });
};
// 尺寸列表
export const measureInfo = params => {
  return axios.request({
    url: "pc/dict/measureInfo",
    method: "get",
    params
  });
};
// 尺寸列表
export const styleMeasureInfo = params => {
  return axios.request({
    url: "pc/dict/styleMeasureInfo",
    method: "get",
    params
  });
};

// 尺码查标准号
export const shapeCategory = params => {
  return axios.request({
    url: "pc/dict/shapeCategory",
    method: "get",
    params
  });
};
// 尺码查标准号
export const standard = params => {
  return axios.request({
    url: "pc/dict/standard",
    method: "get",
    params
  });
};
// 尺码查标准号
export const styleStandard = params => {
  return axios.request({
    url: "/pc/dict/styleStandard",
    method: "get",
    params
  });
};
// 是否有追加西裤按钮
export const isAdd = params => {
  return axios.request({
    url: "pc/dict/isAdd",
    method: "get",
    params
  });
};
// 保存订单
export const saveOrder = data => {
  return axios.request({
    url: "pc/order/saveOrder",
    method: "post",
    data
  });
};
// 订单获取成衣尺寸
export const getFinishedSize = data => {
  return axios.request({
    url: "pc/order/getFinishedSize",
    method: "post",
    data
  });
};
// 查询库存
export const simpleGetFabricStock = params => {
  return axios.request({
    url: "pc/fabric/getFabricStock",
    method: "get",
    params
  });
};
// 查询价格
export const getCraftPrice = data => {
  return axios.request({
    url: "pc/dict/getCraftPrice",
    method: "post",
    data
  });
};
// 成衣尺寸
export const getClothSize = params => {
  return axios.request({
    url: "pc/dict/getCloth",
    method: "get",
    params
  });
};
// padding数量
export const failedAmount = params => {
  return axios.request({
    url: "/pc/order/failedAmount",
    method: "get",
    params
  });
};
// 查询面料价格
export const calculatePrice = params => {
  const encodedCode = encodeURIComponent(params.code);
  return axios.request({
    url: `/pc/style/${params.id}/calculatePrice?fabricCode=${encodedCode}`,
    method: "post",
  });
};



// WEBPACK FOOTER //
// ./src/api/dict.js